import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { Entity, Plan } from "src/app/model/entity";
import { EntityService } from "src/app/services/entity.service";

@Component({
  selector: "app-medical-appointment-plan-auditing",
  templateUrl: "./medical-appointment-plan-auditing.component.html",
  styleUrls: ["./medical-appointment-plan-auditing.component.css"],
})
export class MedicalAppointmentPlanAuditingComponent implements OnInit {
  @Input() plan?: number;
  @Input() entity?: number;
  @Output() planChange: EventEmitter<number | null> = new EventEmitter<number | null>();

  entities: Entity[] = [];
  plans: Plan[] = [];

  filterCompleteEntity: FilterCompleteService<Entity>;
  filterCompletePlan: FilterCompleteService<Plan>;

  formGroup: FormGroup;
  loaded = false;

  constructor(private fb: FormBuilder, private entityService: EntityService) {
    this.formGroup = this.fb.group({
      Entity: [""],
      Plan: [""],
    });

    this.initFilters();
  }

  get filterCompleteEntityOptions() {
    return this.filterCompleteEntity
      ? this.filterCompleteEntity.filteredOptions
      : [];
  }

  get filterCompletePlanOptions() {
    return this.filterCompletePlan
      ? this.filterCompletePlan.filteredOptions
      : [];
  }

  get formIsValid() {
    return this.formGroup.valid;
  }

  async ngOnInit() {
    await this.loadHealthInsurance(this.entity ? this.entity : null);

    this.formGroup.controls.Entity.valueChanges.subscribe(async (value) => {
      this.plans = [];
      this.initPlanFilter();

      this.formGroup.patchValue(
        {
          Plan: null,
        },
        { emitEvent: false }
      );

      if (!value || typeof value === "string") {
        return;
      } else {
        await this.loadInsurancePlan(value, this.plan);
      }
    });

     this.formGroup.controls.Plan.valueChanges.subscribe(async (value) => {
       this.planChange.emit(value ? value.Id : null);
    });
  }

  private async loadHealthInsurance(entityId: number = null) {
    this.entities =
      this.entities.length > 0
        ? this.entities
        : await this.entityService.getEntities();

    this.filterCompleteEntity = new FilterCompleteService<Entity>(
      this.entities,
      this.formGroup.controls.Entity
    );

    if (entityId) {
      const entityIndex = this.entities.findIndex((x) => x.Id === entityId);
      this.formGroup.patchValue(
        {
          Entity: this.entities[entityIndex],
        },
        { emitEvent: false }
      );

      await this.loadInsurancePlan(this.entities[entityIndex], this.plan);
    }
  }

  private initFilters() {
    this.filterCompleteEntity = new FilterCompleteService<Entity>(
      this.entities,
      this.formGroup.controls.Entity
    );

    this.initPlanFilter();
  }

  private initPlanFilter() {
    this.filterCompletePlan = new FilterCompleteService<Plan>(
      this.plans,
      this.formGroup.controls.Plan
    );
  }

  private async loadInsurancePlan(entity: Entity, planId: number = null) {
    this.plans = await this.entityService.getPlansByEntityId(entity.Id);
    this.filterCompletePlan = new FilterCompleteService<Plan>(
      this.plans,
      this.formGroup.controls.Plan
    );

    if (planId) {
      const planIndex = this.plans.findIndex((x) => x.Id === planId);
      this.formGroup.patchValue(
        {
          Plan: this.plans[planIndex],
        },
        { emitEvent: false }
      );
    }
  }
}
